'use client'

import { useId } from 'react'
import { sanitizeMoneyInput } from './format'

interface MoneyFieldProps {
  label: string
  value: string
  onChange: (v: string) => void
  hint?: string
  placeholder?: string
  autoFocus?: boolean
}

/** Campo de dinheiro: prefixo R$ em mono, input mono, foco com anel petróleo. */
export function MoneyField({
  label,
  value,
  onChange,
  hint,
  placeholder = '0,00',
  autoFocus,
}: MoneyFieldProps) {
  const id = useId()
  return (
    <div className="mb-4">
      <label htmlFor={id} className="mb-2 block text-sm text-ink">
        {label}
      </label>
      <div className="flex h-[46px] items-center overflow-hidden rounded-[10px] border border-line bg-surface focus-within:ring-1 focus-within:ring-inset focus-within:ring-brand">
        <span className="flex h-full items-center border-r border-line-soft px-3 font-mono text-sm text-ink-mute">
          R$
        </span>
        <input
          id={id}
          inputMode="decimal"
          value={value}
          placeholder={placeholder}
          autoFocus={autoFocus}
          onChange={(e) => onChange(sanitizeMoneyInput(e.target.value))}
          className="h-full w-full flex-1 bg-transparent px-3 font-mono text-base text-ink outline-none placeholder:text-ink-faint"
        />
      </div>
      {hint && <p className="mt-1.5 text-[11.5px] text-ink-faint">{hint}</p>}
    </div>
  )
}
